// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*overflow-x: hidden;*/
}

* {
  font-family: "Georama", sans-serif;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-tap-highlight-color: transparent;
}

*, *:focus, *:hover {
  outline: none;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

button {
  padding: 0;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}

textarea {
  border: none;
  background: transparent;
  width: 100%;
  height: 100%;
  resize: none;
}
textarea::-webkit-scrollbar {
  display: none;
}

/*#root{*/
/*  display: flex;*/
/*  justify-content: center;*/
/*  align-items: center;*/
#root {
  width: 100%;
  top: 0;
  left: 0;
  color-scheme: only light;
}

.menu {
  padding-top: 96px;
}

.blocking-background {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 10;
  overflow: hidden;
  background-color: rgba(27, 27, 27, 0.4);
  touch-action: none;
}

.container-transparent * {
  opacity: 0;
}

.block-wrapper {
  display: flex;
  justify-content: center;
}

@keyframes enter-animation {
  0% {
    transform: translateY(100px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
@media (prefers-reduced-motion: no-preference) {
  .container-animation > * {
    animation: enter-animation 0.8s 1;
  }
}
.main__content {
  width: 100%;
  position: relative;
}

.grid-table__container {
  overflow: hidden;
}

.container__content {
  flex-grow: 1;
}

@media only screen and (min-device-width: 320px) {
  .main__content {
    min-width: 320px;
  }
  .grid-table__container {
    max-width: 328px;
  }
  .container__content {
    min-width: 320px;
    max-width: 767px;
  }
}
@media only screen and (min-device-width: 768px) {
  .main__content {
    min-width: 768px;
  }
  .grid-table__container {
    max-width: 680px;
  }
  .container__content {
    min-width: 768px;
    max-width: 992px;
  }
}
@media only screen and (min-device-width: 992px) {
  .main__content {
    min-width: 992px;
  }
  .grid-table__container {
    max-width: 1126px;
  }
  .container__content {
    min-width: 992px;
    max-width: 1365px;
  }
}
@media only screen and (min-device-width: 1366px) {
  .main__content {
    min-width: 1366px;
  }
  .grid-table__container {
    max-width: 1210px;
  }
  .container__content {
    min-width: 1366px;
    max-width: 1920px;
  }
}
.grid-table {
  display: grid;
}
.grid-table .t-header {
  background-color: var(--secondary-color);
  padding: 10px;
}
.grid-table .t-row {
  padding: 10px;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,8JAAA;EAGA,mCAAA;EACA,kCAAA;EAEA,sBAAA;AAFF;;AAKA;EACE,kCAAA;EACA,sBAAA;EACA,mDAAA;EACA,wCAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,+EAAA;AAFF;;AAMA;EACE,UAAA;EACA,6BAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AAHF;;AAMA;EACE,YAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAHF;AAKE;EACE,aAAA;AAHJ;;AAOA,SAAA;AACA,mBAAA;AACA,6BAAA;AACA,yBAAA;AAKA;EACE,WAAA;EACA,MAAA;EACA,OAAA;EACA,wBAAA;AARF;;AAWA;EACE,iBAAA;AARF;;AAWA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,uCAAA;EACA,kBAAA;AARF;;AAYE;EACE,UAAA;AATJ;;AAaA;EACE,aAAA;EACA,uBAAA;AAVF;;AAaA;EACE;IACE,4BAAA;IACA,UAAA;EAVF;EAYA;IACE,wBAAA;IACA,UAAA;EAVF;AACF;AAaA;EAEI;IACE,iCAAA;EAZJ;AACF;AAgBA;EACE,WAAA;EAIA,kBAAA;AAjBF;;AAoBA;EACE,gBAAA;AAjBF;;AAoBA;EACE,YAAA;AAjBF;;AAoBA;EACE;IACE,gBAAA;EAjBF;EAmBA;IACE,gBAAA;EAjBF;EAmBA;IACE,gBAAA;IACA,gBAAA;EAjBF;AACF;AAoBA;EACE;IACE,gBAAA;EAlBF;EAoBA;IACE,gBAAA;EAlBF;EAoBA;IACE,gBAAA;IACA,gBAAA;EAlBF;AACF;AAqBA;EACE;IACE,gBAAA;EAnBF;EAqBA;IACE,iBAAA;EAnBF;EAqBA;IACE,gBAAA;IACA,iBAAA;EAnBF;AACF;AAuBA;EACE;IACE,iBAAA;EArBF;EAuBA;IACE,iBAAA;EArBF;EAuBA;IACE,iBAAA;IACA,iBAAA;EArBF;AACF;AAwBA;EACE,aAAA;AAtBF;AAwBE;EACE,wCAAA;EACA,aAAA;AAtBJ;AAyBE;EACE,aAAA;AAvBJ","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n  'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n  sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  /*overflow-x: hidden;*/\n}\n\n* {\n  font-family: 'Georama', sans-serif;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n  -webkit-tap-highlight-color: transparent;\n}\n\n*, *:focus, *:hover {\n  outline: none;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n  monospace;\n}\n\nbutton {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n  outline: none;\n  cursor: pointer;\n}\n\ntextarea {\n  border: none;\n  background: transparent;\n  width: 100%;\n  height: 100%;\n  resize: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n/*#root{*/\n/*  display: flex;*/\n/*  justify-content: center;*/\n/*  align-items: center;*/\n\n//#root{\n//  overflow: auto;\n//}\n#root {\n  width: 100%;\n  top: 0;\n  left: 0;\n  color-scheme: only light;\n}\n\n.menu {\n  padding-top: 96px;\n}\n\n.blocking-background {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  overflow: hidden;\n  background-color: rgba(27, 27, 27, 0.40);\n  touch-action: none;\n}\n\n.container-transparent {\n  * {\n    opacity: 0;\n  }\n}\n\n.block-wrapper {\n  display: flex;\n  justify-content: center;\n}\n\n@keyframes enter-animation {\n  0% {\n    transform: translateY(100px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .container-animation {\n    & > * {\n      animation: enter-animation 0.8s 1;\n    }\n  }\n}\n\n.main__content {\n  width: 100%;\n  //height: 100%;\n  //display: flex;\n  //flex-direction: column;\n  position: relative;\n}\n\n.grid-table__container {\n  overflow: hidden;\n}\n\n.container__content {\n  flex-grow: 1;\n}\n\n@media only screen and (min-device-width: 320px) {\n  .main__content {\n    min-width: 320px;\n  }\n  .grid-table__container {\n    max-width: 328px;\n  }\n  .container__content {\n    min-width: 320px;\n    max-width: 767px;\n  }\n}\n\n@media only screen and (min-device-width: 768px) {\n  .main__content {\n    min-width: 768px;\n  }\n  .grid-table__container {\n    max-width: 680px;\n  }\n  .container__content {\n    min-width: 768px;\n    max-width: 992px;\n  }\n}\n\n@media only screen and (min-device-width: 992px) {\n  .main__content {\n    min-width: 992px;\n  }\n  .grid-table__container {\n    max-width: 1126px;\n  }\n  .container__content {\n    min-width: 992px;\n    max-width: 1365px;\n  }\n\n}\n\n@media only screen and (min-device-width: 1366px) {\n  .main__content {\n    min-width: 1366px;\n  }\n  .grid-table__container {\n    max-width: 1210px;\n  }\n  .container__content {\n    min-width: 1366px;\n    max-width: 1920px;\n  }\n}\n\n.grid-table {\n  display: grid;\n\n  .t-header {\n    background-color: var(--secondary-color);\n    padding: 10px;\n  }\n\n  .t-row {\n    padding: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
